import React from "react";
import { AppDrawer } from "@/components/AppDrawer";
import * as Tabs from "@radix-ui/react-tabs";
import { PabSession } from "@/services/api";
import { SessionsTab } from "./SessionsTab";
import { MessagesTab } from "./MessagesTab";
import { useDrawer } from "@/context/DrawerContext";

interface MultiHubDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  session: PabSession | null;
  defaultTab?: "sessions" | "messages";
}

export const MultiHubDrawer: React.FC<MultiHubDrawerProps> = ({
  isOpen,
  onClose,
  session,
  defaultTab = "messages",
}) => {
  const { multiHubDrawerSelectedAdvisorId } = useDrawer();

  // Don't render if session is null
  if (!session) {
    return null;
  }

  // Redirect "sessions" tab to "messages" since sessions route is now available
  const normalizedDefaultTab = defaultTab === "sessions" ? "messages" : defaultTab;

  return (
    <AppDrawer isOpen={isOpen} onClose={onClose} maxWidth="22.5rem" showCloseButton={true}>
      <div className="w-full">
        {/* Tabs */}
        <Tabs.Root className="w-full" defaultValue={normalizedDefaultTab}>
          <Tabs.List className="flex border-b border-gray-200 mb-4">
            {/* Sessions tab hidden - sessions route is now available */}
            {false && (
              <Tabs.Trigger
                value="sessions"
                className="flex items-center gap-2 px-2 py-2 text-sm font-semibold border-b-2 border-transparent data-[state=active]:border-blue-600 data-[state=active]:text-gray-900 hover:text-gray-700 transition-colors"
              >
                Sessions
              </Tabs.Trigger>
            )}
            <Tabs.Trigger
              value="messages"
              className="flex items-center gap-2 px-2 py-2 text-sm font-normal border-b-2 border-transparent data-[state=active]:border-blue-600 data-[state=active]:text-gray-900 text-gray-600 hover:text-gray-700 transition-colors"
            >
              Messages
            </Tabs.Trigger>
          </Tabs.List>

          {/* Sessions tab content hidden - sessions route is now available */}
          {false && (
            <Tabs.Content value="sessions">
              <SessionsTab session={session} />
            </Tabs.Content>
          )}

          <Tabs.Content value="messages" className="h-full">
            <MessagesTab sessionId={session.id} selectedAdvisorId={multiHubDrawerSelectedAdvisorId} />
          </Tabs.Content>
        </Tabs.Root>
      </div>
    </AppDrawer>
  );
};
